/**
 * 交易车出入记录
 */
import React from "react";

import { Input, Row, Col, Icon, Tooltip, DatePicker, Select } from "antd";
import moment from "moment";
import PageLayout from "../ui/PageLayout";
import BarrierImage from "./BarrierImage";
class BizParkLog extends React.Component {
  columns = [
    {
      title: "上报时间",
      dataIndex: "insertTime",
      width: "20%",
    },
    {
      title: "业务时间",
      dataIndex: "bizTime",
      width: "20%",
    },
    {
      title: "商户",
      dataIndex: "memberName",
      width: "20%",
    },
    {
      title: "VIN",
      dataIndex: "vin",
      width: "20%",
      render: (text, record, index) => (
        <div>{text !== "T" ? text : record.serNo}</div>
      ),
    },
    {
      title: "系统登记车牌号",
      dataIndex: "plateNo",
      width: "10%",
    },
    {
      title: "道闸识别车牌号",
      dataIndex: "gatePlateNo",
      width: "10%",
      render: (text, record, index) => (
        <div>
          {text}
          <Tooltip title="照片">
            <Icon
              type="picture"
              theme="filled"
              title="照片"
              className="table-operate-icon"
              onClick={this.doShowPhoto.bind(this, record)}
            />
          </Tooltip>
        </div>
      ),
    },
    {
      title: "道闸号",
      dataIndex: "gateName",
      width: "10%",
    },
    {
      title: "状态",
      dataIndex: "stateStr",
      width: "10%",
    },
  ];

  state = {
    loadData: "",
    editData: {},
    queryData: {},
  };

  memberSearch = (value) => {
    let queryData = this.state.queryData;
    queryData["memberCode"] = value;
    this.setState({ queryData: queryData });
    this.state.loadData(queryData);
  };

  vinSearch = (value) => {
    let queryData = this.state.queryData;
    queryData["vin"] = value;
    this.setState({ queryData: queryData });
    this.state.loadData(queryData);
  };

  doShowPhoto = (info, e) => {
    this.setState({ editData: info });
    this.setState({ showPhoto: true });
  };

  hidePhoto = () => {
    this.setState({ showPhoto: false });
  };

  onStartChange = (item, val) => {
    let queryData = this.state.queryData;
    queryData["startDateStr"] = val;
    this.setState({ startDateStr: val, queryData });
    this.state.loadData(queryData);
  };

  onEndChange = (item, val) => {
    let queryData = this.state.queryData;
    queryData["endDateStr"] = val;
    this.setState({ endDateStr: val });
    this.state.loadData(queryData);
  };

  selectChange = (value) => {
    let queryData = this.state.queryData;
    queryData.out = value;
    this.setState({ queryData: queryData });
    this.state.loadData(queryData);
  }

  render() {
    return (
      <div style={{ width: "100%", height: "100%" }}>
        <PageLayout
          condition={
            <Row>
              <Col span={20}>
                <Input.Search
                  placeholder="车架号或车牌号"
                  onSearch={this.vinSearch}
                  enterButton
                  style={{ width: "400px" }}
                />
                <DatePicker
                  showTime
                  value={moment(this.state.startDateStr, "YYYY-MM-DD HH:mm")}
                  format="YYYY-MM-DD HH:mm"
                  onChange={this.onStartChange}
                  placeholder="起始时间"
                  style={{marginLeft: "10px"}}
                />
                ~
                <DatePicker
                  showTime
                  value={moment(this.state.endDateStr, "YYYY-MM-DD HH:mm")}
                  format="YYYY-MM-DD HH:mm"
                  onChange={this.onEndChange}
                  placeholder="结束时间"
                />
                <Select defaultValue="" style={{ width: 150, marginLeft: '10px'}} onChange={this.selectChange}>
                    <Select.Option value="">全部出入口</Select.Option>
                    <Select.Option value="0">入口</Select.Option>
                    <Select.Option value="1">出口</Select.Option>
                </Select>
              </Col>
            </Row>
          }
          rowKey="id"
          url="/barrier/bizlog/query"
          columns={this.columns}
          loadData={(func) => {
            this.setState({ loadData: func });
          }}
        />
        <BarrierImage
          visible={this.state.showPhoto}
          onCancel={this.hidePhoto.bind(this)}
          editData={this.state.editData}
        />
      </div>
    );
  }
}

export default BizParkLog;
